import React from "react";
import NumberFormat from "react-number-format";
import { RenderNumber } from "../../../../../../Utils/renderField/renderReadField";
import Paginacion from "../../../../../../Utils/Components/Paginacion/Paginacion";
import { BuscadorExistencias } from "./BuscadorExistencias";
import { getEtiquetasTraslado } from "../helpers/etiquetasTraslado";
import { formatPalletLabel } from "../../../../../ProduccionV2/helpers/formatPallet";

export const TrasladoTable = ({ trasladoForm }) => {
    const {
        destinoTraslado,
        filas,
        valoresATrasladar,
        handleChangeATrasladar,
        tarjetasSalida,
        handleChangeTarjetaSalida,
        search,
        handleSearch,
        cantidadResultados,
        paginaSeleccionada,
        setPaginaSeleccionada,
    } = trasladoForm;

    const destinoEsConforme = destinoTraslado ? destinoTraslado.value : false;

    const {
        labelOrigen,
        labelDestino,
        claseOrigen,
        claseDestino,
        colorTarjeta,
    } = getEtiquetasTraslado(destinoEsConforme);

    return (
        <div className="mt-4">
            <h4 className="mb-3">Pacas de pallets</h4>

            <BuscadorExistencias
                label="Buscar pallet"
                placeholder="Número de pallet"
                search={search}
                handleSearch={handleSearch}
            />

            <div className="new-table-wrapper traslado-control-calidad__table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th
                                colSpan={5}
                                className={`traslado-control-calidad__group-header ${claseOrigen} cell-border-right`}
                            >
                                {labelOrigen}
                            </th>
                            <th
                                colSpan={4}
                                className={`traslado-control-calidad__group-header ${claseDestino}`}
                            >
                                {labelDestino}
                            </th>
                        </tr>
                        <tr>
                            <th>Pallet</th>
                            <th>Pacas iniciales</th>
                            <th>A trasladar</th>
                            <th style={{ minWidth: "150px" }}>
                                Tarjeta {colorTarjeta}
                            </th>
                            <th className="cell-border-right">Pacas finales</th>
                            <th>Pallet</th>
                            <th>Pacas iniciales</th>
                            <th>Trasladado</th>
                            <th>Pacas finales</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filas.length === 0 && (
                            <tr>
                                <td className="text-center" colSpan={9}>
                                    No hay pallets con existencia en bodega
                                </td>
                            </tr>
                        )}
                        {filas.map((fila) => {
                            const pacasInicialesOrigen = destinoEsConforme
                                ? fila.pacas_no_conforme
                                : fila.pacas_conforme;

                            const pacasInicialesDestino = destinoEsConforme
                                ? fila.pacas_conforme
                                : fila.pacas_no_conforme;

                            const valor =
                                Number(valoresATrasladar[fila.pallet_id]) || 0;

                            const pacasFinalesOrigen =
                                pacasInicialesOrigen - valor;

                            const pacasFinalesDestino =
                                pacasInicialesDestino + valor;

                            const huboMovimiento = valor > 0;

                            return (
                                <tr key={fila.pallet_id}>
                                    <td className="text-center text-nowrap">
                                        {formatPalletLabel(
                                            fila.numero_pallet,
                                            fila.identificador_fisico,
                                        )}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderNumber
                                            value={pacasInicialesOrigen}
                                            decimalScale={0}
                                        />
                                    </td>
                                    <td className="text-center">
                                        <div
                                            className="mx-auto"
                                            style={{ maxWidth: "110px" }}
                                        >
                                            <NumberFormat
                                                className="form-control text-center"
                                                value={
                                                    valoresATrasladar[
                                                        fila.pallet_id
                                                    ] || ""
                                                }
                                                thousandSeparator
                                                allowNegative={false}
                                                decimalScale={0}
                                                placeholder="0"
                                                disabled={
                                                    !destinoTraslado ||
                                                    pacasInicialesOrigen <= 0
                                                }
                                                isAllowed={(values) => {
                                                    const { floatValue } =
                                                        values;

                                                    if (
                                                        floatValue === undefined
                                                    ) {
                                                        return true;
                                                    }

                                                    return (
                                                        floatValue >= 0 &&
                                                        floatValue <=
                                                            pacasInicialesOrigen
                                                    );
                                                }}
                                                onValueChange={(values) =>
                                                    handleChangeATrasladar(
                                                        fila.pallet_id,
                                                        values.floatValue || 0,
                                                    )
                                                }
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <div
                                            className="mx-auto"
                                            style={{ maxWidth: "110px" }}
                                        >
                                            <input
                                                type="text"
                                                className="form-control text-center"
                                                value={
                                                    tarjetasSalida[
                                                        fila.pallet_id
                                                    ] || ""
                                                }
                                                placeholder="No. tarjeta"
                                                disabled={!huboMovimiento}
                                                onChange={(e) =>
                                                    handleChangeTarjetaSalida(
                                                        fila.pallet_id,
                                                        e.target.value,
                                                    )
                                                }
                                            />
                                        </div>
                                    </td>
                                    <td
                                        className={`text-center text-nowrap cell-border-right
                                            ${
                                                huboMovimiento
                                                    ? "traslado-control-calidad__cell-highlight"
                                                    : "traslado-control-calidad__cell-highlight-gray"
                                            }`}
                                    >
                                        <RenderNumber
                                            value={pacasFinalesOrigen}
                                            decimalScale={0}
                                        />
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {formatPalletLabel(
                                            fila.numero_pallet,
                                            fila.identificador_fisico,
                                        )}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderNumber
                                            value={pacasInicialesDestino}
                                            decimalScale={0}
                                        />
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <RenderNumber
                                            value={valor}
                                            decimalScale={0}
                                        />
                                    </td>
                                    <td
                                        className={`text-center text-nowrap 
                                            ${
                                                huboMovimiento
                                                    ? "traslado-control-calidad__cell-highlight"
                                                    : "traslado-control-calidad__cell-highlight-gray"
                                            }`}
                                    >
                                        <RenderNumber
                                            value={pacasFinalesDestino}
                                            decimalScale={0}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <Paginacion
                cantidadResultados={cantidadResultados}
                paginaSeleccionada={paginaSeleccionada}
                setPaginaSeleccionada={setPaginaSeleccionada}
            />
        </div>
    );
};
